import React from "react";
// @ts-ignore
import ReactDOM from "react-dom";
import CloseIcon from "@material-ui/icons/Close";
import { AlertOptions } from "@View/components/ui/alert/alert-context";

const getTextColor = (level: string) => {
  switch (level) {
    case "error":
      return "#d32f2f";
    case "warn":
      return "#ed6c02";
    default:
      return "#333";
  }
};

const SystemAlert = ({
  title,
  text,
  level = "info",
  onClose = () => {},
}: AlertOptions) => {
  return ReactDOM.createPortal(
    <div className="modal-backdrop">
      <div className="modal-window">
        <h2 className="modal-title" style={{ color: getTextColor(level) }}>
          {title}
        </h2>
        <CloseIcon onClick={onClose} className="modal-close" />
        <p
          className="modal-text"
          style={{ color: getTextColor(level) }}
          dangerouslySetInnerHTML={{ __html: text.replaceAll("\n", "<br/>") }}
        ></p>
      </div>
    </div>,
    document.body
  );
};

export default SystemAlert;
